module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff?5e405c16c959bec402cc00609e9806f9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff
// module id = OWsp
// module chunks = 29